import { render } from "./MMReportList.vue?vue&type=template&id=1b25c984"
import script from "./MMReportList.vue?vue&type=script&lang=js"
export * from "./MMReportList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__